export default "__VITE_ASSET__B86NdKlZ__"